// Contact Support form shown while the runtime `helpSupport` flag is off (PROD before the Help release).
import React, { useState } from 'react';
import { useTranslation } from '../context/TranslationContext';
import { sendEmail } from '../helpers/apiHelper';
import { getDestinationEmail } from '../helpers/emailHelper';
import '../styles/SupportForm.css';
import { useAuth } from '../context/AuthContext';

const SupportFormLegacy = () => {
  const { t, language } = useTranslation();
  const { user, tokens } = useAuth();

  const [enquiryType, setEnquiryType] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const fromEmail = user?.email;

  const enquiryOptions = ['option1', 'option2'];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fromEmail ) return;
    const enquiryTypeLabel = enquiryType ? t(`supportForm.${enquiryType}`) : '';
    const formType = language === 'pt' ? 'portuguese' : 'english';

    const destinationEmail = getDestinationEmail(
      formType,
      enquiryType
    );

    // Plain text only: an HTML body is blocked by the API WAF (CrossSiteScripting_BODY).
    // The backend reads the enquiry type from the subject and the whole body as the message.
    const payload = {
      destinationEmail,
      fromEmail,
      subject: `Coco Support – ${enquiryTypeLabel || enquiryType}`,
      body: message,
    };

    setError('');
    try {
      setIsSubmitting(true);
      await sendEmail(payload, tokens.idToken);
      setSubmitted(true);
    } catch (err) {
      console.error('Failed to send support request:', err);
      setError(t('supportForm.send_error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="support-form">
        <h2>{t('supportForm.thank_you_title')}</h2>
        <p>{t('supportForm.thank_you_message')}</p>
      </div>
    );
  }

  return (
    <form className="support-form" onSubmit={handleSubmit}>
      <h2>{t('supportForm.title')}</h2>

      <div className="form-group">
        <label htmlFor="enquiryType">
          {t('supportForm.enquiry_type_label')}
        </label>
        <select
          id="enquiryType"
          value={enquiryType}
          onChange={(e) => setEnquiryType(e.target.value)}
          required
        >
          <option value="">
            {t('supportForm.enquiry_type_placeholder')}
          </option>

          {enquiryOptions.map((key) => (
            <option key={key} value={key}>
              {t(`supportForm.${key}`)}
            </option>
          ))}
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="message">
          {t('supportForm.message_label')}
        </label>
        <textarea
          id="message"
          rows="5"
          value={message}
          placeholder={t('supportForm.message_placeholder')}
          onChange={(e) => setMessage(e.target.value)}
          required
        />
      </div>

      {error && (
        <div className="support-form-error" role="alert">
          <p>{error}</p>
        </div>
      )}

      <div className="modal-buttons">
        <button
          type="submit"
          className="modal-button update"
          disabled={!enquiryType || !message || isSubmitting}
        >
          {isSubmitting ? t('updating') : t('supportForm.submit_button')}
        </button>
      </div>
    </form>
  );
};

export default SupportFormLegacy;
